import * as React from 'react';

import { Slug } from '@fnv-core/utils';

import { FormControlProps } from '../interfaces/FormControlProps';

import { FormStylingHelpers } from './helpers/FormStylingHelpers';
import { FormLabelHelpers } from './helpers/FormLabelHelpers';
import { PropertyHelpers } from '../helpers/PropertyHelpers';
import { FormControlHelpers } from './helpers/FormControlHelpers';
import { LabelAndPopover } from './components/label-and-popover';
import { getResourceString } from '../kentico/resource-strings';
import { StringHelpers } from '../helpers/StringHelpers';

export interface InputState {
    dataSourceCounter: number;
    timer: any;
    rows: number;
    minRows: number;
    maxRows: number;
    isLoading: boolean;
    hasFocus: boolean;
}

export class Textarea extends React.Component<FormControlProps, InputState> {
    constructor(props: FormControlProps) {
        super(props);
        this.textarea = React.createRef();
    }

    state = {
        dataSourceCounter: 0,
        timer: undefined,
        rows: 2,
        minRows: 2,
        maxRows: 100,
        isLoading: false,
        hasFocus: false
    };

    textarea: any;

    componentDidMount() {
        this.calculateTextareaHeight();
    }

    calculateTextareaHeight = () => {
        if (this.textarea && this.textarea.current) {
            const textareaLineHeight = 24;
            const { minRows, maxRows } = this.state;
            
            const previousRows = this.textarea.current.rows;
            this.textarea.current.rows = minRows; 
            
            const currentRows = Math.floor(this.textarea.current.scrollHeight / textareaLineHeight);
            if (currentRows === previousRows) {
                this.textarea.current.rows = currentRows;
            }
            
            if (currentRows >= maxRows) {
                this.textarea.current.rows = maxRows;
                this.textarea.current.scrollTop = this.textarea.current.scrollHeight;
            }
            
            this.setState({            
                rows: currentRows < maxRows ? currentRows : maxRows,
            });   
        }
    }

    handleChange = (event) => {
        event.persist();
        this.calculateTextareaHeight();
        FormControlHelpers.inputProperties(this).onChange(event);
    }

    onInputFocus = (event) => {                
        this.setState({hasFocus : true});
    }

    onInputBlur = (event) => {
        if (event.persist) {
            event.persist();
        }
        this.setState({hasFocus : false}, () => {
            this.props.field.onBlur(event);
        });
    }

    private getTextAreaValueAndNewLines = () => {
      let textAreaValue = this.props.field.value;
      let newLines = textAreaValue.match(/(\r\n|\n|\r)/g);
      let addition = newLines !== null ? newLines.length : 0;
      return { textAreaValue, addition };
    }
    
    render() {
        const inputProperties = {
            // Input properties has everything needed to deal with manual input
            // It will load related data when a datasource is set
            ...FormControlHelpers.inputProperties(this)
        };
        
        const maxLength = PropertyHelpers.getMaxLength(this.props, 500);
       
        //Some browsers counts new lines as 2, we need to check for new lines in the text area value and add it to the length.     
        let { textAreaValue, addition } = this.getTextAreaValueAndNewLines();
      
        const data = {
            count: (textAreaValue || "").length + addition,
            maxchars : maxLength
        };
        
        let textAreaMaxLength = maxLength - addition;
        const disabled = !!this.props.formFieldDefinition.readOnly;
        const textAreaHint = StringHelpers.replacePropertiesInString(getResourceString("Form.Textarea.Hint"), data, true);

        return (
            <div className={FormStylingHelpers.getFormGroupStyle(this.props) + ' form__section-input ' + Slug.fromString(this.props.formFieldDefinition.name) + '-textarea-form-group'}>
                <LabelAndPopover 
                    fieldId={PropertyHelpers.getFieldID(this.props)} 
                    label={FormLabelHelpers.getFieldLabel(this)}
                    explanation={this.props.formFieldDefinition.explanation}
                    hasPopover={this.props.formFieldDefinition.hasPopover}                    
                ></LabelAndPopover>
                <div className="input-group">
                    <textarea                        
                        rows={this.state.rows}
                        {...inputProperties}
                        maxLength={textAreaMaxLength}
                        onChange={this.handleChange}
                        onFocus={this.onInputFocus}
                        onBlur={this.onInputBlur}
                        disabled={disabled}
                        className={"mijn-fnv__textarea " + FormStylingHelpers.getInputStyle(this) + " " +
                            (!!this.state.hasFocus ? "has-focus" : "")}
                        ref={this.textarea}
                    >{this.props.field.value != null ? this.props.field.value : ""}</textarea>
                    <div className="input-group-append form-control--is-valid-indicator">
                        <div className="input-group-text">
                            <span className="icon icon-checkmark" />
                        </div>
                    </div>
                    <div className="w-100 textarea__counter">
                        <span>{textAreaHint}</span>
                    </div>
                    {!this.state.hasFocus && FormControlHelpers.invalidFeedbackComponent(this)}
                </div>
            </div>
        );
    }
}